// extracted by mini-css-extract-plugin
module.exports = {"no_data":"ScreenerTableComponent_no_data__l6YO_"};